import './SubjectComment.less';

import React from 'react';

import { SubjectCommentsCommand } from './commands/SubjectCommentsCommand';
import Comment from './comment/index';

interface IProps {
	data: SubjectCommentsCommand | undefined;
	refresh: () => void;
	editable: boolean;
	subjectId: string;
	setEditable: (
		editable: boolean,
		id: string | undefined,
		visible: boolean
	) => void;
}

const SubjectComment = (props: IProps) => {
	const { data } = props;

	return (
		<div className="antsay-ui">
			<div className="antsay-commentbox">
				<div className="antsay-commentbox-header">
					<p>Liczba komentarzy {data?.pagination.total}</p>
				</div>
			</div>
			<div className="antsay-comments">
				{data?.comments.map((comment, i) => (
					<Comment
						key={`comment-${i}`}
						data={comment}
						subjectId={props.subjectId}
						refresh={props.refresh}
						setEditable={props.setEditable}
					/>
				))}
			</div>

			{data?.pagination.hasNextPage && (
				<div className="antsay-more">Pokaż więcej</div>
			)}
		</div>
	);
};

export default SubjectComment;
